<div
  class="box-border flex flex-col items-center h-full gap-3 py-5 px-9 bg-neutrals-100"
>
  <div class="flex justify-start items-center w-[1223px] min-h-[29.33px]">
    <!-- Close element -->
    <button
      class="grid items-center justify-start grid-flow-col gap-2"
      (click)="close.emit()"
    >
      <ui-icon name="chevron-left" fill="neutrals-600" m-size="24" size="24" />
      <ui-paragraph type="p14" mobile-type="p14" text-color="neutrals-600">
        Regresar
      </ui-paragraph>
    </button>
  </div>
  <div
    class="box-border flex flex-col items-center justify-start h-[600px] max-h-[600px] w-[1223px] bg-neutrals-300 border-neutrals-300 rounded-[8px] py-6 overflow-y-auto"
  >
    <div
      *ngIf="date; else timeAvailabilityLoading"
      class="box-border w-[900px] h-full flex flex-col gap-4"
    >
      <div class="flex flex-row">
        <ui-headline
          type="h16"
          mobile-type="h16"
          font-weight="semibold"
          text-color="neutrals-900"
        >
          Fecha requerida
        </ui-headline>
      </div>
      <div class="flex flex-row gap-6">
        <div class="w-[220px]">
          <unicon-text-select-field
            [dropdown]="true"
            [value]="date"
            icon="calendar"
            (selected)="onSelectedDate($event)"
          />
        </div>
        <div class="w-[220px]">
          <unicon-text-select-field
            [value]="selectedTime"
            icon="clock"
            [placeholder]="placeholderClock"
          />
        </div>
        <div class="w-[220px]">
          <unicon-text-select-field value="Solo Mixer" icon="truck" />
        </div>
        <div class="w-[220px]">
          <unicon-text-select-field value="Planta San juan" icon="cedi" />
        </div>
      </div>
      <div class="flex flex-row items-center gap-6" *ngIf="firstResult">
        <div class="w-[150px] flex-none flex flex-row items-center justify-end">
          <ui-headline
            type="h12"
            mobile-type="h12"
            font-weight="semibold"
            text-color="neutrals-900"
          >
            Fecha
          </ui-headline>
        </div>
        <div class="flex-grow flex flex-row gap-[2px] relative">
          <div
            class="flex flex-grow"
            *ngIf="!availabilityIsLoading; else timeIsLoading"
          >
            <div
              class="bg-neutrals-0 border-neutrals-400 rounded-[8px] box-border p-2 flex-1 flex flex-col justify-center items-center gap-0"
              *ngFor="let day of firstResult.results[0].availability"
            >
              <ui-paragraph
                type="p10"
                mobile-type="p10"
                text-color="neutrals-700"
              >
                {{ day.dayName }}
              </ui-paragraph>
              <ui-paragraph
                type="p10"
                mobile-type="p10"
                text-color="neutrals-700"
              >
                {{ day.startDateTime | date: 'dd/MM/YYYY' }}
              </ui-paragraph>
            </div>
          </div>
          <ng-template #timeIsLoading>
            <div class="w-[105px] h-[50px] flex-grow flex">
              <div
                class="bg-neutrals-0 border-neutrals-400 rounded-[8px] box-border p-2 flex-1 flex flex-col justify-center items-center gap-1"
                *ngFor="let a of arr"
              >
                <ngx-skeleton-loader
                  count="1"
                  appearance="line"
                  [theme]="{
                    marginBottom: '0px',
                    width: '75px',
                    height: '10px',
                  }"
                />
                <ngx-skeleton-loader
                  count="1"
                  appearance="line"
                  [theme]="{
                    marginBottom: '0px',
                    width: '75px',
                    height: '10px',
                  }"
                />
              </div>
            </div>
          </ng-template>
          <button
            class="bg-[#F2BC32] absolute top-[50%] translate-y-[-50%] left-0 translate-x-[-50%] rounded-[50px] w-6 h-6 flex justify-center items-center shadow-sm hover:opacity-85 hover:scale-125 transition-all disabled:bg-neutral-400 disabled:transition-none"
            [disabled]="firstResult.page === 1"
            (click)="onPreviousPage()"
          >
            <ui-icon
              name="chevron-left"
              [attr.fill]="
                firstResult.page === 1 ? 'neutrals-0' : 'neutrals-900'
              "
              m-size="16"
              size="16"
            />
          </button>
          <button
            class="bg-[#F2BC32] absolute top-[50%] translate-y-[-50%] right-0 translate-x-[50%] rounded-[50px] w-6 h-6 flex justify-center items-center shadow-sm hover:opacity-85 hover:scale-125 transition-all"
            [disabled]="firstResult.page === firstResult.lastPage"
            (click)="onNextPage()"
          >
            <ui-icon
              name="chevron-right"
              [attr.fill]="
                firstResult.page === firstResult.lastPage
                  ? 'neutrals-0'
                  : 'neutrals-900'
              "
              m-size="16"
              size="16"
            />
          </button>
        </div>
      </div>
      <div
        class="flex flex-col gap-[2px] max-h-[560px] overflow-auto"
        *ngIf="!availabilityIsLoading && firstResult; else availabilitySkeleton"
      >
        <div
          class="flex flex-row items-center gap-6"
          *ngFor="let row of firstResult.results"
        >
          <div
            class="w-[150px] h-[100%] flex-none bg-neutrals-0 border-neutrals-400 rounded-[8px] box-border p-1 flex flex-col justify-center items-center gap-0"
          >
            <ui-paragraph
              type="p10"
              mobile-type="p10"
              text-color="neutrals-900"
            >
              {{ row.time }}
            </ui-paragraph>
          </div>
          <div class="flex-grow flex flex-row gap-[2px] relative">
            <button
              class="rounded-[8px] box-border p-3 flex-1 flex flex-col justify-center items-center gap-0 transition-all"
              [ngClass]="{
                'bg-[#AFF190] border-[1px] border-[#D2DEF1] cursor-pointer hover:border-black':
                  time.isAvailable && !time.isSelected,
                'bg-neutrals-200 border-neutrals-400 cursor-not-allowed':
                  !time.isAvailable,
                'bg-[#FFF7E0] border-[3px] border-[#E6B51A] cursor-pointer !hover:border-[#E6B51A]':
                  time.isAvailable && time.isSelected,
              }"
              *ngFor="let time of row.availability"
              (click)="onSelectedTime($event, time)"
            >
              <ui-paragraph
                type="p10"
                mobile-type="p10"
                [attr.textColor]="
                  time.isAvailable ? 'neutrals-900' : 'neutrals-500'
                "
                [attr.fontWeight]="time.isAvailable ? 'semibold' : 'regular'"
              >
                {{ time.isAvailable ? 'Disponible' : 'No disponible' }}
              </ui-paragraph>
            </button>
          </div>
        </div>
      </div>
      <ng-template #availabilitySkeleton>
        <div class="flex flex-col gap-[2px] max-h-[560px] overflow-auto mb-7">
          <div class="flex flex-row items-center gap-6" *ngFor="let a of arr">
            <div
              class="w-[150px] h-[100%] flex-none bg-neutrals-0 border-neutrals-400 rounded-[8px] box-border p-1 flex flex-col justify-center items-center gap-2"
            >
              <ngx-skeleton-loader
                count="2"
                appearance="line"
                [theme]="{
                  marginBottom: '0px',
                  width: '55px',
                  height: '16px',
                }"
              />
            </div>
            <div class="flex-grow flex flex-row gap-[2px] relative">
              <div
                *ngFor="let a of arr"
                class="w-[100px] rounded-[8px] box-border p-3 flex-1 flex flex-col justify-center items-center gap-0 transition-all"
              >
                <ngx-skeleton-loader
                  count="1"
                  appearance="line"
                  [theme]="{
                    marginBottom: '0px',
                    width: '75px',
                    height: '16px',
                  }"
                />
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <div class="flex flex-row justify-center">
        <button
          [disabled]="!form.valid"
          class="min-w-[151px] box-border flex flex-row gap-2 justify-center items-center px-4 rounded-[8px] cursor-pointer min-h-[36px] bg-unicon-yellow-100 disabled:bg-[#A9BCD9] disabled:cursor-not-allowed mt-5 md:mt-0"
          type="submit"
          (click)="onConfirm()"
        >
          <ui-icon
            name="invoice"
            [fill]="form.valid ? 'primary-700' : 'neutrals-0'"
            m-size="16"
            size="16"
            *ngIf="!isLoading"
          />
          <ui-paragraph
            type="p14"
            mobile-type="p14"
            [textColor]="form.valid ? 'primary-700' : 'neutrals-0'"
            font-weight="semibold"
            *ngIf="!isLoading"
          >
            Confirmar
          </ui-paragraph>
          <ui-loader type="secondary" size="md" *ngIf="isLoading" />
        </button>
      </div>
    </div>
    <ng-template #timeAvailabilityLoading>
      <div class="flex w-[950px] mb-[10px] justify-start">
        <ngx-skeleton-loader
          count="1"
          appearance="line"
          [theme]="{ marginBottom: '0px', width: '200px', height: '32px' }"
        />
      </div>
      <div class="flex flex-row gap-6 mb-6">
        <ngx-skeleton-loader
          count="1"
          appearance="line"
          [theme]="{ marginBottom: '0px', width: '220px', height: '40px' }"
        />
        <ngx-skeleton-loader
          count="1"
          appearance="line"
          [theme]="{ marginBottom: '0px', width: '220px', height: '40px' }"
        />
        <ngx-skeleton-loader
          count="1"
          appearance="line"
          [theme]="{ marginBottom: '0px', width: '220px', height: '40px' }"
        />
        <ngx-skeleton-loader
          count="1"
          appearance="line"
          [theme]="{ marginBottom: '0px', width: '220px', height: '40px' }"
        />
      </div>
      <div class="flex flex-row items-center gap-6">
        <div class="w-[150px] flex-none flex flex-row items-center justify-end">
          <ngx-skeleton-loader
            count="1"
            appearance="line"
            [theme]="{ marginBottom: '0px', width: '150px', height: '18px' }"
          />
        </div>
        <div class="flex-grow flex flex-row gap-[2px] relative">
          <div
            class="w-[105px] h-[50px] bg-neutrals-0 border-neutrals-400 rounded-[8px] box-border p-2 flex-1 flex flex-col justify-center items-center gap-1"
            *ngFor="let a of arr"
          >
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{
                marginBottom: '0px',
                width: '85px',
                height: '10px',
              }"
            />
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{
                marginBottom: '0px',
                width: '85px',
                height: '10px',
              }"
            />
          </div>
          <div
            class="absolute top-[50%] translate-y-[-50%] left-0 translate-x-[-50%] rounded-[50px] w-6 h-6 flex justify-center items-center shadow-sm hover:opacity-85 hover:scale-125 transition-all disabled:bg-neutral-400 disabled:transition-none"
          >
            <ngx-skeleton-loader
              count="1"
              appearance="circle"
              [theme]="{
                marginBottom: '0px',
                width: '16px',
                height: '16px',
                backgroundColor: '#F2BC32',
              }"
            />
          </div>
          <div
            class="absolute top-[50%] translate-y-[-50%] right-0 translate-x-[50%] rounded-[50px] w-6 h-6 flex justify-center items-center shadow-sm hover:opacity-85 hover:scale-125 transition-all"
          >
            <ngx-skeleton-loader
              count="1"
              appearance="circle"
              [theme]="{
                marginBottom: '0px',
                width: '16px',
                height: '16px',
                backgroundColor: '#F2BC32',
              }"
            />
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-[2px] max-h-[560px] overflow-auto mb-7">
        <div class="flex flex-row items-center gap-6" *ngFor="let a of arr">
          <div
            class="w-[150px] h-[100%] flex-none bg-neutrals-0 border-neutrals-400 rounded-[8px] box-border p-1 flex flex-col justify-center items-center gap-2"
          >
            <ngx-skeleton-loader
              count="2"
              appearance="line"
              [theme]="{
                marginBottom: '0px',
                width: '55px',
                height: '16px',
              }"
            />
          </div>
          <div class="flex-grow flex flex-row gap-[2px] relative">
            <div
              *ngFor="let a of arr"
              class="w-[105px] rounded-[8px] box-border p-3 flex-1 flex flex-col justify-center items-center gap-0 transition-all"
            >
              <ngx-skeleton-loader
                count="1"
                appearance="line"
                [theme]="{
                  marginBottom: '0px',
                  width: '75px',
                  height: '16px',
                }"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-row justify-center">
        <div
          class="w-[152px] box-border flex flex-row justify-center items-center px-4 rounded-[8px] h-[36px] mt-5 md:mt-0"
        >
          <ngx-skeleton-loader
            count="1"
            appearance="line"
            [theme]="{
              marginBottom: '0px',
              width: '152px',
              height: '36px',
              backgroundColor: '#F2BC32',
            }"
          />
        </div>
      </div>
    </ng-template>
  </div>
</div>
